<template>
    <div class="infor-detail">
      <div class="sign-header"><img :src="detail.cover" alt=""></div>
        <div class="sign-body">
            <div class="sign-title">{{detail.title}}</div>
            <div class="sign-content" v-html="detail.content"></div>
        </div>
    </div>

</template>
<script>
    import {Cell, CellGroup,Field,RadioGroup, Radio,Button,List} from 'vant'
    import './detail.less'
    import util from 'libs/utils'

    export default {
        name: "coinRecord",
        components: {
            vanCell:Cell, 
            vanCellGroup:CellGroup,
            vanField:Field,
            vanRadioGroup:RadioGroup,
            vanRadio:Radio,
            vanButton:Button,
            List
        },
        data() {
            return {
                detail:''
            }
        },
        methods: {
            getdetail(){
                let id = this.$route.params.id
                this.$api.system.getZlistdetail({id:id}).then((res)=>{
                    if(res.code==200){
                        this.detail = res.data
                    }
                })
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.getdetail()
            })
        }
    }
</script>
